export const INITIAL_STATE = {
  imageCollection: [],
  isFileNameExists: false,
};

const imageStorageReducer = (state = INITIAL_STATE, data) => {
  switch (data.type) {
    case 'SET_IMAGE_COLLECTION':
      return {
        ...state,
        imageCollection: data.imageCollection,
      };
    case 'SET_FILE_NAME_EXISTS_STATE':
      return {
        ...state,
        isFileNameExists: data.isFileNameExists,
      };
    default:
      return state;
  }
};

export default imageStorageReducer;

export const INITIAL_STATE_VALUE = {
  myInterActives: [],
  globalInteractives: [],
  sharedInteractives: [],
};

export const embedReducer = (state = INITIAL_STATE_VALUE, action: any) => {
  switch (action.type) {
    case 'MY_INTERACTIVES':
      return {
        ...state,
        myInterActives: action.myInterActives || [],
      };
    case 'GLOBAL_INTERACTIVES':
      return {
        ...state,
        globalInteractives: action.globalInteractives || [],
      };
    case 'SHARED_INTERACTIVES':
      return {
        ...state,
        sharedInteractives: action.sharedInteractives || [],
      };
    default:
      return state;
  }
};
